import React from 'react';
import classes from './setting_toggle.module.scss';
import { ReactComponent as CheckIcon } from '../../../../../assets/icons/check.svg';

const settingsData = [
  {
    title: 'Show by',
    fields: [
      {
        path: 'dealCreated',
        label: 'Deal created',
      },
      {
        path: 'expectedCloseDate',
        label: 'Expected close date',
      },
    ],
  },
  {
    title: 'Change interval',
    fields: [
      {
        path: 'week',
        label: 'Week',
      },
      {
        path: 'month',
        label: 'Month',
      },
    ],
  },
  {
    title: 'Number of columns',
    fields: [
      {
        path: 'columns3',
        label: '3 columns',
      },
      {
        path: 'columns4',
        label: '4 columns',
      },
      {
        path: 'columns5',
        label: '5 columns',
      },
    ],
  },
];

function SettingToggle(props) {
  return (
    <div
      role="button"
      tabIndex="0"
      className={classes.wrapper}
      onClick={(e) => e.stopPropagation()}
    >

      {settingsData.map((s) => (
        <div key={s.title}>
          <p className={classes.title}>{s.title}</p>

          {s.fields.map((f) => (
            <div
              key={f.path}
              role="button"
              tabIndex="0"
              className={`${classes.child} ${f.path === 'week' && classes.active}`}
            >
              <p>{f.label}</p>

              <CheckIcon />
            </div>
          ))}
        </div>
      ))}

    </div>
  );
}

export default SettingToggle;
